// extracted by mini-css-extract-plugin
export default {"tableMargin":"form_tableMargin__1Vi5J"};